

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';


export type ClearJobsMutationProps = {
    status: string;
}

export interface QueueClearResponse {
    success: boolean;
    queueName: string;
    statuses: string[];
    processedCount: number;
    removedCount: number;
    message: string;
  }


export const useClearJobsMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (model: ClearJobsMutationProps):Promise<QueueClearResponse> => {
            const response = await del<QueueClearResponse>(`/v1.0/internals/queues?status=${model.status}`);
            return response.data;
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['ClipExportQueueStatus'] })
    });
};

export default useClearJobsMutation;
